export default __webpack_public_path__ + "static/media/apt-logo.60a43048.svg";